import { useCallback, useState } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from '@/auth/AuthContext';
import { AppShell } from '@/components/layout/AppShell';
import { ProtectedRoute } from '@/components/layout/ProtectedRoute';
import { AccountPage } from '@/pages/AccountPage';
import { AssetsPage } from '@/pages/AssetsPage';
import { ForgotPasswordPage } from '@/pages/ForgotPasswordPage';
import { GameDetailPage } from '@/pages/GameDetailPage';
import { GuidelinesPage } from '@/pages/GuidelinesPage';
import { HomePage } from '@/pages/HomePage';
import { LibraryPage } from '@/pages/LibraryPage';
import { RoadmapPage } from '@/pages/RoadmapPage';
import { SignInPage } from '@/pages/SignInPage';
import type { HubCategory } from '@/types';

const FALLBACK_CATEGORIES: HubCategory[] = [
  { id: 'live', label: 'Live' },
  { id: 'slot', label: 'Slot' },
  { id: 'instant', label: 'Instant', comingSoon: true },
];

function ShellRoutes() {
  const [categories, setCategories] = useState<HubCategory[]>(FALLBACK_CATEGORIES);
  const [activeCategory, setActiveCategory] = useState('live');

  const handleCategoriesLoaded = useCallback((cats: HubCategory[]) => {
    setCategories(cats);
  }, []);

  return (
    <Routes>
      <Route
        element={
          <AppShell
            categories={categories}
            activeCategory={activeCategory}
            onCategoryChange={setActiveCategory}
          />
        }
      >
        <Route index element={<HomePage />} />
        <Route
          path="library"
          element={
            <LibraryPage
              onCategoriesLoaded={handleCategoriesLoaded}
              onCategoryChange={setActiveCategory}
            />
          }
        />
        <Route path="library/:gameId" element={<GameDetailPage />} />
        <Route path="roadmap" element={<RoadmapPage />} />
        <Route path="assets" element={<AssetsPage />} />
        <Route path="guidelines/*" element={<GuidelinesPage />} />
        <Route path="account" element={<AccountPage />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/signin" element={<SignInPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/*" element={<ShellRoutes />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
